/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_SubtitleInputs */

const en_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dutch Passion Thailand`)
};

const th_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดัตช์ แพสชั่น ไทยแลนด์`)
};

const ja_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dutch Passion Thailand`)
};

const fr_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dutch Passion Thailand`)
};

const es_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dutch Passion Thailand`)
};

const ru_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dutch Passion Thailand`)
};

const zh_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dutch Passion Thailand`)
};

const vi_chat_subtitle = /** @type {(inputs: Chat_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dutch Passion Thailand`)
};

/**
* | output |
* | --- |
* | "Dutch Passion Thailand" |
*
* @param {Chat_SubtitleInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const chat_subtitle = /** @type {((inputs?: Chat_SubtitleInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_SubtitleInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_chat_subtitle(inputs)
	if (locale === "ja") return ja_chat_subtitle(inputs)
	if (locale === "fr") return fr_chat_subtitle(inputs)
	if (locale === "es") return es_chat_subtitle(inputs)
	if (locale === "ru") return ru_chat_subtitle(inputs)
	if (locale === "zh") return zh_chat_subtitle(inputs)
	if (locale === "vi") return vi_chat_subtitle(inputs)
	return en_chat_subtitle(inputs)
});